import axios from 'axios';
import { IReferralHistoryCollection, IReferralHistoryParams, IReferralSummaryModel } from 'entities/Referral/Referral.models';

const basePath = '/customers/me/referral';

export const referralTransport = {
  getReferralSummary: (): Promise<IReferralSummaryModel> => {
    return axios.get(basePath);
  },
  getReferralHistory: (params: IReferralHistoryParams): Promise<IReferralHistoryCollection> => {
    return axios.get(`${basePath}/history`, { params });
  },
  markReferralRewardSeen: (): Promise<void> => {
    return axios.post(`${basePath}/seen`);
  },
};
